// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__326aq","description":"PatientConsentPreview_description__2pIZr"};